import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AtributosProjeto } from 'src/app/shared/models/atributos-projeto.model';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { MaskService } from 'src/app/shared/services/mask.service';
import { OrgaoService } from 'src/app/shared/services/orgao.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoList } from '../../models/projeto-list.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastroService } from '../../services/projeto-cadastro.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { NavigationService } from '../../services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';


@Component({
  selector: 'app-detalhe-cadastro-projeto-edit',
  templateUrl: './detalhe-cadastro-projeto-edit.component.html',
  styleUrls: ['./detalhe-cadastro-projeto-edit.component.scss']
})
export class DetalheCadastroProjetoEditComponent extends BaseFormComponent<ProjetoList> implements OnInit {

  idProjeto: number;
  infoProjeto: any;
  actionLabel: string = 'Editar';
  dateInputMask: any;
  value: number;
  orgaoList: Orgao[];
  usuarioList: Usuario[];
  bsValue = new Date();
  attrList: AtributosProjeto;
  values_budget_monitoring: any;
  values_budget_monitoring_exec: any;
  values_actived: any;
  values_level_monitor: any;
  values_irfe_enabled: any;
  values_ircp_enabled: any;
  values_type_project: any;
  values_op_status_id: any;
  values_sgo_program_id: any;
  values_obj_est_id: any;
  orgao_id: any;
  funding_user_cpf: string;
  list_pg: any;
  monitor_list: any[];
  monitor_list_gl: any[];
  tipoGestao: number;
  permissions: ProjetoPermission;
  projeto: ProjetoCadastro;
  user_info: any;
  audit: AtualizacoesAudit;

  readonly gestaoLocal = 0;
  readonly gestaoIntensiva = 1;

  constructor(
    private storage: StorageService,
    private myService: ProjetoCadastroService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    public maskService: MaskService,
    public orgaoService: OrgaoService,
    public irfeProjetoService: IrfeProjetoService,
    public ircpProjetoService: IrcpProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.attrList = this.activatedRoute.snapshot.data["listAtributosProjeto"];

    this.tipoGestao = 0;
    this.idProjeto = this.activatedRoute.parent.parent.snapshot.params.idProjeto;
    this.pesquisaGeralService.info.subscribe(info => this.infoProjeto = info);
    this.orgaoService.getAll(this.idProjeto).subscribe((res) => {
      this.orgaoList = res;
    });

    this.values_budget_monitoring = this.attrList.budget_monitoring;
    this.values_budget_monitoring_exec = this.attrList.budget_monitoring_exec;
    this.values_actived = this.attrList.actived;
    this.values_level_monitor = this.attrList.level_monitor;
    this.values_irfe_enabled = this.attrList.irfe_enabled;
    this.values_ircp_enabled = this.attrList.ircp_enabled;
    this.values_type_project = this.attrList.type_project
    this.values_op_status_id = this.attrList.op_status_id
    this.values_sgo_program_id = this.attrList.sgo_program_id
    this.values_obj_est_id = this.attrList.obj_est_id;
    this.funding_user_cpf = this.attrList.funding_user_cpf;
    this.list_pg = this.attrList.list_pg;
    this.monitor_list = this.attrList.monitor_list;
    this.monitor_list_gl = this.attrList.monitor_list_gl;

    if (!this.permissions.edit_check) {
      this.toastr.error('Você não possui permissão para editar este projeto!');
      this.router.navigate([`projetos/projeto/${this.idProjeto}/cadastro`]);
    }

    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      id: new FormControl(''),
      title: new FormControl('', [Validators.required]),
      ds_reason: new FormControl(''),
      ds_goal: new FormControl(''),
      ds_target: new FormControl(''),
      ds_assumptions: new FormControl(''),
      ds_requirements: new FormControl(''),
      ds_restrictions: new FormControl(''),
      description: new FormControl(''),
      value: new FormControl(''),
      agency_id: new FormControl(null, [Validators.required]),
      user_cpf: new FormControl(null),
      manager_cpf: new FormControl(null),
      dt_foreseen_start: new FormControl('', [Validators.required]),
      dt_foreseen_end: new FormControl('', [Validators.required]),
      cron_dt_foreseen_start: new FormControl(null),
      cron_dt_foreseen_conclusion: new FormControl(null),
      cron_executed: new FormControl(0),
      source: new FormControl(''),
      budget_monitoring: new FormControl('1', [Validators.required]),
      exec_budget_table_show: new FormControl('0', [Validators.required]),
      actived: new FormControl('1', [Validators.required]),
      level_priority: new FormControl('0', [Validators.required]),
      monitor_id: new FormControl(null),
      irfe_enabled_id: new FormControl('0', [Validators.required]),
      ircp_enabled_id: new FormControl('0', [Validators.required]),
      type_project: new FormControl('1', [Validators.required]),
      op_status_id: new FormControl('1', [Validators.required]),
      status_ok: new FormControl('', [Validators.pattern(/^\d+$/), Validators.max(100)]),
      status_warn: new FormControl('', [Validators.pattern(/^\d+$/), Validators.max(100)]),
      status_alert: new FormControl('', [Validators.pattern(/^\d+$/), Validators.max(100)]),
      pg_id: new FormControl(''),
      program: new FormArray([]),
      sgo_program: new FormControl(null),
      obj_est_id: new FormControl(''),
      manager_adjunct: new FormArray([]),
    });

    if (this.entity) {
      this.form.patchValue(this.entity);
      this.form.get('value').setValue(this.entity?.value?.replace(/\./g, '')?.replace(',', '.') ?? '0');
      if (this.entity?.manager_adjunct) {
        this.entity?.manager_adjunct.forEach((item) => {
          this.getFormArray().push(new FormControl(item.user_cpf));
        });
      }
      if (this.entity?.program?.length > 0) {
        this.entity?.program.forEach((item) => {
          this.getProgramFormArray().push(new FormControl(item));
        });
      }
      else{
        this.getProgramFormArray().push(new FormControl(null));
      }

      this.tipoGestao = this.form.get('level_priority').value;
      this.loaded();
      this.audit = {
        pf_id: this.entity.id
      };
    } else {
      this.user_info = this.storage.getInfoUser();
      this.orgaoService.getOrganUser(this.user_info.str_cpf_pk).subscribe(
        (res) => {
          this.orgao_id = res.orgao;
          this.form.get('agency_id').setValue(this.orgao_id);
        });
      this.loaded();
    }

  }

  changeLevelPriority(e): void {
    this.tipoGestao = e.id;
  }

  addNewAdjunctManager() {
    this.getFormArray().push(new FormControl(null));
  }

  addNewProgram() {
    this.getProgramFormArray().push(new FormControl(null));
  }

  removeAdjunctManager(index: number) {
    this.getFormArray().removeAt(index);
  }

  removeProgramManager(index: number) {
    this.getProgramFormArray().removeAt(index);
  }

  getFormArray(): FormArray {
    return this.form.get('manager_adjunct') as FormArray;
  }

  getProgramFormArray(): FormArray {
    return this.form.get('program') as FormArray;
  }

  voltar() {
    if (this.idProjeto) {
      this.navigation.back([`projetos/projeto/${this.idProjeto}/cadastro`]);
    } else {
      this.navigation.back([`projetos/projeto`]);
    }
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    data.pf_id = this.idProjeto;

    data.dt_foreseen_start = this.organizaData(data.dt_foreseen_start)
    data.dt_foreseen_end = this.organizaData(data.dt_foreseen_end)
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.idProjeto) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.idProjeto).subscribe({
            next: (res: ProjetoCadastro) => {
              this.updateInfoProject();
              this.msgSuccess('Cadastro alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.error)
              this.loaded();
            },
          })
        );
      }
      else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProjetoCadastro) => {
              this.idProjeto = res.pf_id;
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'cadastro', 'editar']);
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.error);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  updateInfoProject() {
    this.pesquisaGeralService.infoProjeto(this.idProjeto).subscribe({
      next: (info) => {
        this.infoProjeto = info;
        this.pesquisaGeralService.setInfoProject(this.infoProjeto);
      },
    });
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.idProjeto).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Projeto excluído com sucesso!').subscribe(() => {
          this.navigation.replace([`projetos/projeto`]);
        })
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }
}
